/* Botanica PDP — turn the Judge.me review row into a carousel with ◀ ▶ arrows.
   Judge.me loads reviews asynchronously, so we poll for the list, then wrap it
   with prev/next buttons. Arrows only appear when the row actually overflows
   (i.e. there are more reviews than fit), and disable at each end. */
(function () {
  var host = document.querySelector('.pdp__reviews');
  if (!host) return;

  function makeArrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bb-rev-arrow bb-rev-arrow--' + (dir < 0 ? 'prev' : 'next');
    b.setAttribute('aria-label', dir < 0 ? 'Previous reviews' : 'Next reviews');
    b.innerHTML = dir < 0
      ? '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>'
      : '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
    return b;
  }

  function setup(list) {
    if (list.dataset.bbCarousel) return;
    list.dataset.bbCarousel = '1';

    var wrap = document.createElement('div');
    wrap.className = 'bb-rev-carousel';
    list.parentNode.insertBefore(wrap, list);

    var prev = makeArrow(-1);
    var next = makeArrow(1);
    wrap.appendChild(prev);
    wrap.appendChild(list);
    wrap.appendChild(next);

    function step() {
      var card = list.querySelector('.jm-review-item');
      return card ? card.offsetWidth + 18 : 280;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });

    function update() {
      var overflow = list.scrollWidth > list.clientWidth + 4;
      wrap.classList.toggle('has-arrows', overflow);
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 1500); // re-check after images/fonts settle
  }

  var tries = 0;
  var timer = setInterval(function () {
    var list = host.querySelector('.jdgm-review-list');
    if (list && list.querySelector('.jm-review-item')) {
      setup(list);
      clearInterval(timer);
    }
    if (++tries > 50) clearInterval(timer);
  }, 400);

  /* Close the Judge.me write-review modal on backdrop click (2026-07-16).
     Judge.me exposes no setting for this — clicking the grey area around the
     white card (.__content) triggers the widget's own close button, so its
     internal state stays consistent. Clicks INSIDE the card are untouched. */
  document.addEventListener('click', function (e) {
    var modal = e.target.closest && e.target.closest('.jdgm-write-review-modal');
    if (!modal) return;
    if (e.target.closest('.jdgm-write-review-modal__content')) return; // inside the card
    var close = modal.querySelector('.jdgm-write-review-modal__close-btn');
    if (close) close.click();
  }, true);
})();
